export const strongHubo = [
  {
    giho: 1,
    name: '이재명',
    jd_name: '더불어민주당',
    color: '#3F69FF',
  },
  {
    giho: 2,
    name: '윤석열',
    jd_name: '국민의힘',
    color: '#E61E2B',
  },
  {
    giho: 3,
    name: '심상정',
    jd_name: '정의당',
    color: '#f5e730',
  },
  {
    giho: 4,
    name: '안철수',
    jd_name: '국민의당',
    color: '#EA5504',
  },
];
